module.exports = {
  "calendar": "Kalender",
  "day": "Tag",
  "dayPeriod": "Tagesh\xE4lfte",
  "endDate": "Enddatum",
  "era": "Epoche",
  "hour": "Stunde",
  "minute": "Minute",
  "month": "Monat",
  "second": "Sekunde",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Ausgew\xE4hltes Datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Ausgew\xE4hlter Bereich: ".concat(args.startDate, " bis ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Ausgew\xE4hlte Zeit: ".concat(args.time);
  },
  "startDate": "Anfangsdatum",
  "timeZoneName": "Zeitzone",
  "weekday": "Wochentag",
  "year": "Jahr"
};